// Flag globale per abilitare/disabilitare i log di debug
const DEBUG_MODE = true;

// Livelli di debug: 1 = base, 2 = dettagliato, 3 = molto dettagliato
const DEBUG_LEVEL = 3;

// Funzione di utility per i log di debug
export const debugLog = (component, action, data, level = 1) => {
  if (DEBUG_MODE && level <= DEBUG_LEVEL) {
    const timestamp = new Date().toISOString().substr(11, 12);
    console.log(`[DEBUG][${timestamp}][${component}][${action}]`, data);
  }
};

// Funzione per tracciare gli errori
export const debugError = (component, action, error) => {
  console.error(`[ERROR][${component}][${action}]`, error);
  console.trace(); // Aggiunge stack trace per facilitare il debug
};
